import { PanoComponent } from './panoComponent';
import { createPriceBoard, createDot } from './components/lead/index';
import DearApi from '../../apis/dealer.api';
import {
  userActionInterceptor,
  staticIdDecorator,
} from '../socketIO/user.action.interceptor';
import store from '../../store';
import util from '../../utils/util';
import { RotateCar } from './rotate.car';
import pvTrackService from '../pvtrack.service';
import { DotsPina } from '../setDots.service';
import dealerApi from '../../apis/dealer.api';
import { Logger } from '../logger';
/**
 * @classs
 * @classdesc
 * @desc 4d看看相关功能封装
 * @author  songshichao <songshichao@autohome.com.cn>
 * @document https://docs.4dkankan.com/#/
 * @github https://github.com/4Dage-Developer/4dage-sdk
 */
@staticIdDecorator('PanoComponent')
class Kankan4D extends PanoComponent {
  /**
   *
   * @param { Object } initSettings
   */
  constructor(initSettings) {
    super(initSettings);
    this._promiseMap = {};
    this.logger = new Logger('Kankan4D');
    this.initSettings = initSettings;
    this.loadedPromiseResolve = null;
    this.loadedPromise = new Promise((resolve) => {
      this.loadedPromiseResolve = resolve;
    });
    // initSettings['sceneId'] ='KJ-mgVeKJdoYZa2';
    this.readyPromise = new Promise((resolve) => {
      this.loadScript().then(() => {
        this.render(resolve, initSettings['sceneId']);
      });
    });
    this.dotsPinaService = null;
  }
  loadScript() {
    const flvPrmose = util.loadScript({
      id: 'kankan-sdk-flv',
      src: PUBLIC_PATH + 'lib/flv.min.js',
      cross: true,
    });

    const depsPrmose = util
      .loadScript({
        id: 'kankan-sdk-deps',
        src: PUBLIC_PATH + 'lib/kankan-sdk-deps.js',
        cross: true,
      })
      .then(() => {
        if (window.THREE) {
          const sdkPromise = util.loadScript({
            id: 'kankan-sdk',
            src: PUBLIC_PATH + 'lib/kankan-sdk.js',
            cross: true,
          });
          return sdkPromise;
        } else {
          this.logger.error('window.THREE 未定义');
        }
      })
      .catch((error) => {
        this.logger.error('依赖脚本加载失败！', error);
      });

    return Promise.all([flvPrmose, depsPrmose]);
  }
  /**
   * 初始化相关信息和插件
   * @todo 删除默认项目编号 KJ-JYo2ZZyKKJ
   */
  render(resolve, sceneId) {
    // TODO 换成接口返回的projectNum
    // console.log('sceneId', sceneId);
    this.kankan = new window.KanKan({
      dom: '#pano',
      num: sceneId,
      server: 'https://4d.m.autohome.com.cn/',
      resource: 'https://vrs3three.autohome.com.cn/',
      mobile: true,
      useStatistics: false,
    });

    // 使用小地图插件
    // kankan.use('MinMap');
    this.initSceneEvents(resolve);
    this.initCameraEvents();
    // this.initStoreEvents(); // 暂时隐藏
    this.useTagView();
    this.kankan.render();
  }

  /**
   * 获取promise
   * @param promiseName promiseName
   * @param creator promise创建者
   * @returns
   */
  _getPromise(promiseName, creator) {
    let promise = this._promiseMap[promiseName];
    if (!promise) {
      promise = creator();
      this._promiseMap[promiseName] = promise;
    }
    return promise;
  }

  /**
   * 初始场景祥光事件处理
   * @param {*} resolve
   */
  initSceneEvents(resolve) {
    const self = this;
    const kankan = self.kankan;
    kankan.Scene.on('error', (data) => {
      console.log('错误', data);
    });
    kankan.Scene.on('ready', () => {
      resolve();
    });
    kankan.Scene.on('loaded', (pano) => {
      this.initPlayerEvents();
      self.loadedPromiseResolve();
      console.log('所有资源加载完成');
    });
    self.getTours();
    self.getFloors();
  }
  /**
   * 初始player相关事件
   */
  initPlayerEvents() {
    const self = this;
    const kankan = self.kankan;
    const player = kankan.core.get('Player');
    // events:
    // move：移动,
    // rotate：旋转
    // zoom：缩放
    // endRotation：结束旋转
    // moveModel：移动模型
    // mode.changed：模式切换
    // flying.started：切换点位开始
    // flying.ended：切换点位结束
    // mode.changing
    // pano.chosen
    // closest.pano.changing
    // flyin.finished
    // ready
    // start.inside
    // start.outside
    // view.changed
    // warp.interrupted.flyto
    // input.start
    if (!util.isICSApp()) {
      Promise.resolve().then(() => {
        this.initRotateCarData(store.state.specDot.rotateCarData, player);
      });
    }
    player.on('rotate', function ({ currentPanoId, quaternion }) {
      // 旋转事件
      if (quaternion) {
        self.sendRotatePos(
          currentPanoId,
          quaternion._x,
          quaternion._y,
          quaternion._z,
          quaternion._w,
        );
      } else {
        console.error('rotate-quaternion', quaternion);
      }
    });
    /**
     * @todo 惯性移动问题未解决
     */
    player.on('endRotation', function () {
      // console.log('endRotation', JSON.stringify(arguments[0]));
      function sendRotatePos() {
        const quaternion = kankan.Camera.getPose().quaternion;
        if (quaternion) {
          // 旋转事件
          self.sendRotatePos(
            player.currentPano.id,
            quaternion._x,
            quaternion._y,
            quaternion._z,
            quaternion._w,
          );
        } else {
          console.error('endRotation-quaternion', quaternion);
        }
      }
      sendRotatePos();
      // 禁止惯性滑动
      setTimeout(() => {
        // 获取将旋转速度值同步到另一端
        player.cameraControls.activeControl.locked = false;
        player.cameraControls.activeControl.rotationSpeed.set(0, 0);
        const handler = () => {
          // console.log('endRotation-update');
          sendRotatePos();
          if (
            player.cameraControls.activeControl.rotationSpeed.x === 0 &&
            player.cameraControls.activeControl.rotationSpeed.y === 0
          ) {
            player.off('update', handler);
          }
        };
        player.on('update', handler);
      }, 0);

      window.kankan = kankan;
    });

    player.on('zoom', function () {
      // 缩放事件， 缩放之前
      // console.log('Player-zoom', arguments, kankan.Camera.getPose());
    });
    player.on('zoomTo', function (zoomLevel) {
      //  缩放事件， 缩放之后
      self.sendZoom(zoomLevel);
      // console.log('Player-zoomTo', arguments, this, kankan.Camera.getPose());
    });

    kankan.core
      .get('PanoVideoRenderer')
      .videoPlayer.on('panovideo.start', function () {
        pvTrackService.pvTrackLogger({ action: 'ZNZT_2023chick_04' });
      });
  }
  /**
   * 初始相机相关事件处理
   */
  initCameraEvents() {
    const self = this;
    const kankan = self.kankan;
    kankan.Camera.on(
      'mode.beforeChange',
      ({ fromMode, toMode, floorIndex }) => {
        // console.log('mode.beforeChange', fromMode, toMode, floorIndex);
      },
    );
    kankan.Camera.on('mode.afterChange', ({ toMode, floorIndex }) => {
      // console.log('mode.afterChange', toMode, floorIndex);
    });
    kankan.Camera.on('flying.started', (pano) => {
      self.sendFlyPano(pano.panoId);
      if (store.state.phoneCall.phoneCallStatus) {
        kankan.Camera.lock();
      }
      console.log('flying.started', pano);
    });
    kankan.Camera.on('flying.ended', ({ targetPano }) => {
      if (store.state.phoneCall.phoneCallStatus) {
        kankan.Camera.unlock();
      }
      // console.log('flying.ended', targetPano, arguments);
    });
    kankan.Camera.on('zoom', (params) => {
      // console.log('camera-zoom', params);
    });
    kankan.Camera.on('pano.chosen', function () {
      // console.log('pano.chosen', arguments);
    });
    kankan.Camera.on('closest.pano.changing', function () {
      // console.log('closest.pano.changing', arguments);
    });
  }
  /**
   * 初始store相关事件
   */
  initStoreEvents() {
    const self = this;
    const kankan = self.kankan;
    kankan.store.on('metadata', (metadata) => {
      console.log('场景数据', metadata);
    });
    kankan.store.on('floorcad', (floor) => {
      console.log('楼层数据', floor);
    });
    kankan.store.on('tags', (floor) => {
      console.log('热点数据', floor);
    });
    kankan.store.on('tours', (tour) => {
      console.log('导览数据1', tour);
    });
  }
  /**
   * 获取热点自定义数据
   * @returns Promise
   */
  getHotspot() {
    const param = {
      cityId: this.initSettings.cityId,
      dealerId: this.initSettings.dealerId,
      sceneId: this.initSettings.sceneId,
    };
    console.log(param);
    return DearApi.getAnchorList(param);
  }

  /**
   * @method
   * @param { String } sid 热点唯一标识
   * @desc 通过热点id查找热点业务数据
   * @return { * } 热点扩展数据
   */
  findHotSpotBySid(item) {
    return {
      hotspotId: item.sid,
      seriesId: item.seriesId,
      specId: item.specId,
      salesInfo: item.salesInfo,
      seriesName: item.seriesName,
      specName: item.specName,
      dealerNewPrice: item.dealerNewPrice,
      maxOriginalPrice: item.maxOriginalPrice,
      downPrice: item.downPrice,
      score: item.seriesReputationScore,
      has3d: item.has3dModel === 1 ? true : false,
      sceneName: '',
      sceneId: item.sceneId,
      facRebateAmount: item.facRebateAmount,
      jumpUrl: item.jumpUrl,
      type: item.type,
      position: item.position,
      typeId: item.typeId,
    };
  }
  /**
   * 下个瞬间
   * @param {*} callBack
   * @todo 调用获取热点数据完成后渲染热点
   */
  nextTick(callBack) {
    Promise.resolve().then(callBack);
  }
  /**
   * 使用热点插件
   */
  useTagView() {
    const self = this;
    const kankan = self.kankan;
    this.getHotspot().then((res) => {
      res.forEach((item) => {
        if (item.type === 2) {
          item.panoIds = [item.panoId];
        }
      });
      this.dotsPinaService = new DotsPina(res);
      const array = self.getHotsData(res);
      kankan.store.set('tags', { icons: [], tags: array });
      kankan
        .use('TagView', {
          render(data) {
            if (data.type === 'car-card') {
              return `<div id="${data.sid}" type="${data.type}"></div>`;
            } else if (data.type === 'car-dot') {
              return `<span id="${data.sid}" type="${data.type}"></span>`;
            } else {
              return `<span id="${data.sid}" type="${data.type}" style="width:0;height:0;"></span>`;
            }
          },
        })
        .then((TagView) => {
          console.log('TagView-ready', TagView, kankan.Scene);
          if (
            kankan.Scene &&
            kankan.Scene.panos &&
            kankan.Scene.panos.list &&
            kankan.Scene.panos.list.length > 0
          ) {
            kankan.TagManager.add(array);
            self.renderedHots(array);
          }
        });
    });
  }
  /**
   * 主打车初始化
   * @param {*} RotateCarData
   * @param {*} player
   * @returns
   */
  initRotateCarData(RotateCarData, player) {
    const self = this;
    if (!RotateCarData || RotateCarData.length === 0) {
      return;
    }
    const rotateCarData = RotateCarData.filter(
      (o) => o.sceneId === self.initSettings.sceneId,
    );
    let carDirection = null;
    let panoIds = rotateCarData.reduce((pre, cur) => {
      return pre.concat(cur.panoIds);
    }, []);
    const panoIdsString = panoIds.map((o) => String(o));
    this.dotsPinaService.setPanoIds(panoIdsString);
    for (let i = 0; i < rotateCarData.length; i++) {
      let item = rotateCarData[i];
      const eightCar = new RotateCar(
        player,
        item.panoIds.map((o) => String(o)),
      );
      eightCar.on(
        'car.rotated',
        function ({ direction, panoId, centerPoint, quaternion }) {
          console.log(
            'car.rotated',
            direction,
            panoId,
            centerPoint,
            quaternion,
          );
          self.fly(panoId, centerPoint, 1000);
        },
      );
      carDirection = eightCar.carDirection;
    }
    player.on('flying.ended', ({ targetPano }) => {
      if (!carDirection) {
        return;
      }
      if (store.state.phoneCall.phoneCallStatus) {
        carDirection.hide();
        return;
      }
      if (panoIdsString.includes(targetPano.id)) {
        if (!store.state.isSHowSmartGuide) {
          carDirection.show();
        } else {
          carDirection.hide();
        }
      } else {
        carDirection.hide();
      }
    });
  }
  // 此处添加锚点vue
  renderedHots(renderList) {
    renderList.forEach((data) => {
      let extendData = this.findHotSpotBySid(data);
      if (extendData && extendData.type === 'car-card') {
        this.nextTick(() => createPriceBoard(data.sid, extendData, this));
      }
      if (extendData && extendData.type === 'car-dot') {
        this.nextTick(() => createDot(data.sid, extendData, this));
      }
    });
  }
  getHotsData(hotsData) {
    return hotsData.map((hot) => {
      const isCarCard = hot.type === 1;
      return {
        createTIme: new Date().getTime(),
        x: hot.horizX,
        y: hot.horizY,
        position: {
          x: hot.posX,
          y: isCarCard && hot.posY > 0 ? 0.2822032018635102 : hot.posY, //hot.posY,
          z: hot.posZ,
        },
        icon: hot.icon,
        panoId: hot.panoId,
        sid: `car-card-${hot.anchorId}`,
        title: hot.title,
        seriesId: hot.seriesId,
        specId: hot.specId,
        salesInfo: hot.salesInfo,
        seriesName: hot.seriesName,
        specName: hot.specName,
        dealerNewPrice: hot.dealerNewPrice,
        maxOriginalPrice: hot.maxOriginalPrice,
        downPrice: hot.downPrice,
        seriesReputationScore: hot.seriesReputationScore, //分数
        has3dModel: hot.has3dModel,
        sceneName: '',
        sceneId: hot.sceneId,
        facRebateAmount: hot.facRebateAmount,
        jumpUrl: hot.jumpUrl,
        type: isCarCard ? 'car-card' : hot.type === 2 ? 'car-dot' : '',
        typeId: hot.subType,
        visiblePanos: hot.panoIds,
      };
    });
  }
  /**
   * 获取位置点信息
   * @returns {
   *   position: Vector3, // 相机位置
   *   quaternion: Quaternion, // 旋转角度
   *   panoId: Number, // 场景id
   *   zoomLevel: Number // 缩放级别
   * }
   */
  getPos() {
    var pose = this.kankan.Camera.getPose();
    return pose;
  }
  /**
   *
   * @param { Number } zoomLevel 设置缩放级别
   */
  zoom(zoomLevel) {
    this.kankan.core.get('Player').zoomTo(zoomLevel);
  }
  /**
   * 发送旋转角度
   * @param { Number } x x坐标
   * @param { Number } y y坐标
   * @param { Number } z z坐标
   * @param { Number } w w坐标
   */
  @userActionInterceptor({ methodName: 'setRotate' })
  sendRotatePos(panoId, x, y, z, w) {
    // console.log(x, y, z, w)
  }
  /**
   * 设置旋转角度
   * @param { Number } x x坐标
   * @param { Number } y y坐标
   * @param { Number } z z坐标
   * @param { Number } w w坐标
   */
  setRotate(panoId, x, y, z, w) {
    const quaternion = new window.THREE.Quaternion(x, y, z, w);
    this.rotate(panoId, quaternion);
  }
  /**
   * 旋转到指定角度
   * kankan.Camera.getPose().quaternion
   * @param { Quaternion } point
   */
  rotate(panoId, point) {
    this.loadedPromise.then(() => {
      var player = this.kankan.core.get('Player');
      player.cameraControls.activeControl.locked = false;
      player.cameraControls.activeControl.camera.quaternion.set(
        point._x,
        point._y,
        point._z,
        point._w,
      );
      const lookAtPoint = new window.THREE.Vector3(0, 0, -1)
        .applyQuaternion(player.cameraControls.activeControl.camera.quaternion)
        .add(player.cameraControls.activeControl.camera.position);
      player.cameraControls.activeControl.lookAt(lookAtPoint);
    });
  }

  // key: "rotateEnd",
  // value: function(e) {
  //   var t = this.app.core.get("Player");
  //   t.cameraControls.activeControl.locked = !1, e.rotationSpeed && (t.cameraControls.activeControl.rotationSpeed = new THREE.Vector2(e.rotationSpeed.x, e.rotationSpeed.y))
  // }

  /**
   * 发送缩放值
   * @param { number } zoomLevel
   */
  @userActionInterceptor({ methodName: 'setZoomLevel' })
  sendZoom(zoomLevel) {
    console.log(zoomLevel);
  }
  /**
   * 设置缩放级别
   * @param {*} zoomLevel
   */
  setZoomLevel(zoomLevel) {
    var player = this.kankan.core.get('Player');
    player.zoomTo(zoomLevel);
  }
  /**
   * 发送场景切换
   * @param {*} panoId 场景id
   * @param {*} lookatPoint 朝向点
   * @param {*} duration 时长
   */
  @userActionInterceptor({ methodName: 'fly' })
  sendFlyPano(panoId, lookatPoint, duration) {
    // console.log(panoId, lookatPoint, duration);
  }
  /**
   * 切换场景
   * @param { String } panoId 场景id
   * @param { Vector3 } lookatPoint 朝向点
   * @param { Number } duration 时长
   */
  @userActionInterceptor({ methodName: 'fly' })
  fly(panoId, lookatPoint, duration, quaternion) {
    return this.loadedPromise.then(() => {
      return new Promise((resolve) => {
        let vec = null;
        if (lookatPoint) {
          vec = new window.THREE.Vector3(
            lookatPoint.x,
            lookatPoint.y,
            lookatPoint.z,
          );
        }
        var player = this.kankan.core.get('Player');
        let targetPano = player.model.panos.index[panoId];
        player.flyToPano(
          {
            pano: targetPano,
            lookAtPoint: vec,
            duration,
            quaternion: quaternion
              ? new window.THREE.Quaternion(
                  quaternion._x,
                  quaternion._y,
                  quaternion._z,
                  quaternion._w,
                )
              : null,
          },
          () => {
            resolve();
          },
        );
      });
    });
  }

  /**
   * 缩略图点击
   * @param { string } panoId 场景id
   */
  thumbnailClick(panoId) {
    console.log('thumbnailClick', panoId);
  }
  /**
   * 自动旋转
   * @param { Boolean } rotate 是否自动选装
   */
  autorotate(rotate) {
    if (util.isICSApp()) {
      return;
    }
    const player = this.kankan.core.get('Player');
    const currentPanoId = player.$app.Scene.panoId;
    player.emit('flying.ended', {
      targetPano: {
        id: currentPanoId,
      },
    });
  }
  /**
   * 同步场景
   * @todo 同步场景
   * @todo 同步视角
   */
  syncScene() {
    // sendFlyPano
    const kankan = this.kankan;
    const pos = kankan.Camera.getPose();

    this.sendFlyPano(pos.panoId);
    this.sendRotatePos(
      pos.panoId,
      pos.quaternion._x,
      pos.quaternion._y,
      pos.quaternion._z,
      pos.quaternion._w,
    );
    console.log('autorotate', kankan.Camera.getPose());
  }

  /**
   * 获取导览数据
   * @returns
   */
  getTours() {
    const param = {
      dealerId: this.initSettings.dealerId,
      sceneId: this.initSettings.sceneId,
    };
    return this._getPromise('getTour', () => {
      return dealerApi.getTourList(param);
    });
  }
  getFloors() {
    const kankan = this.kankan;
    return this._getPromise('getFloors', () => {
      return new Promise((resolve) => {
        kankan.store.on('floorcad', (floors) => {
          console.log('楼层数据', floors);
          resolve(floors);
        });
      });
    });
  }
}

export { Kankan4D };
